export const emptyDiv = "None here";
export const successTitle = "Transaction Successful!";
export const listTransactonsTitle = "List of Recent Transactions";
export const transactionsLink = "Click Here";
export const done = "Done";
export const enqueuedTitle = "Transaction Enqueued!";
export const applyTitle = "Application Submitted!";
